import { render, staticRenderFns } from "./Statements.vue?vue&type=template&id=f830d52e&scoped=true"
import script from "./Statements.vue?vue&type=script&lang=js"
export * from "./Statements.vue?vue&type=script&lang=js"
import style0 from "./Statements.vue?vue&type=style&index=0&id=f830d52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f830d52e",
  null
  
)

export default component.exports